module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3WEuq"))).then(() => parcelRequire('37nVf'));